<template>
  <section class="app-main">
    <!--  -->
    <div class="env">
      <div class="box">
        <span>
          <i class="el-icon-warning"></i> 当前环境为{{
            envName ? envName : "UAT"
          }}环境！</span
        >
      </div>
      <!-- <el-alert
        type="warning"
        center
        style="width: 100%; margin-top: 10px"
        @close="closeFn"
      >
        <div slot="title" class="alert-content">
          <svg-icon icon-class="horn"></svg-icon>
          <span class="alert-text">您的系统使用期将在90天后到期，为了维持您的服务和支持，如需延长使用时长，请在3个月内完成续订，以避免中断服务。</span>
        </div>
      </el-alert> -->
    </div>
    <div class="main">
      <transition name="fade-transform" mode="out-in">
        <keep-alive :include="cachedViews">
          <router-view :key="key" />
        </keep-alive>
      </transition>
    </div>
  </section>
</template>

<script>
export default {
  name: "AppMain",
  data() {
    return {
      envName: sessionStorage.getItem("iwrs_environment") || "UAT",
    };
  },
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    key() {
      return this.$route.path;
    },
  },
};
</script>

<style lang="scss" scoped>
.env {
  margin: 10px 20px;
  .box {
    height: 30px;
    line-height: 30px;
    background: #e6f7ff;
    border: 1px dashed #91d5ff;
    text-align: center;
    span {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #7aa9cf;
    }
  }
//   .box1 {
//     height: 30px;
//     line-height: 30px;
//     background: #FFFBE6;
//     border: 1px dashed #FFE58F;
//     .subBox {
//       width: 700px;
//       margin: 0 auto;
//       animation: line 8s linear infinite alternate;
//     }
//     span {
//       font-size: 16px;
//       font-family: PingFangSC-Medium, PingFang SC;
//       font-weight: 500;
//       color: #FAAD14;
//     }
//   }
// }
// @keyframes line{
//   0%{
//     transform: translateX(30%);
//   }
//   100%{
//     transform: translateX(-30%);
//   }
}
.main {
  width: 98%;
  min-height: 86vh;
  padding: 20px;
  margin: 0 auto;
  height: 100%;
  background-color: #fff;
}
.app-main {
  /* 50= navbar  50  */
  min-height: calc(100vh - 50px);
  width: 100%;
  position: relative;
  overflow: hidden;
  background-color: #f0f5ff;
}

.fixed-header + .app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 84px);
  }

  .fixed-header + .app-main {
    padding-top: 84px;
  }
}
.el-alert {
  border: 1px dashed #ffa335;
  background-color: #ffebd8;

  .alert-content {
    white-space: nowrap;
    animation: sport 20s linear infinite;
  }
  @keyframes sport {
    0% {
    }
    100% {
      transform: translateX(calc(200px - 100%));
    }
  }

  .alert-text {
    color: #ffa335;
    font-size: 16px;
    font-family: PingFangSC-Medium;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
// .el-popup-parent--hidden {
//   .fixed-header {
//     padding-right: 15px;
//   }
// }
</style>
